import Selection from "./selection";

class Visibility extends Selection {
    reverse;

    constructor(props) {
        super(props);
        this.reverse = props.reverse ? props.reverse : false;
    }

    async execute({training}) {
        for (let i = 0; i < this.models.length; i++) {
            let model = this.models[i];
            this.models[i] = training.resources[model] ? training.resources[model].name : model;
        }

        const modelIds = new Set();
        if (this.reverse) {
            if (this.models.length > 0) {
                modelIds.add(training.resources[this.models[0].id].resourceId);
            }

            for (let volume of this.volumes) {
                modelIds.add(modelManager.getModelIdByBranchId(volume.id));
            }
        } else {
            for (let model of this.models) {
                modelIds.add(training.resources[model.id].resourceId);
            }

            for (let volume of this.volumes) {
                modelIds.add(modelManager.getModelIdByBranchId(volume.id));
            }

            for (let branch of this.branches) {
                const branchNode = MeshHierarchyViewFeatureData.getDataFromBranchID(branch.id);
                modelIds.add(branchNode.modelId);
            }

            for (let group of this.groups) {
                modelIds.add(GroupData.getModelIdFromGroupId(group.id));
            }
        }

        //stop GLB animations for models
        for (let modelId of modelIds) {
            const modelObj = modelManager.getModelById(modelId);
            if (modelObj) {
                await modelObj.animationController.stopAnimation();
            }
        }

        performVisibility(this);
    }
}

export default Visibility;
